export default __webpack_public_path__ + "images/5144110a3e5d36b091e0ffcad81a7d46.png";